let isRtl : boolean | null = null;

export default function() : boolean {
    if(isRtl === null && document.documentElement) {
        isRtl = (document.documentElement.dir || '').toLowerCase().trim() === 'rtl';
    }

    return isRtl || false;
}